import isKnownUser from "astrid-firestore/src/api/users/utils/isKnownUser";
import createStore from "astrid-helpers/src/createStore";

import { onProfile } from "./profile";

// Whether the profile grants access to anything; only set when it changes, so listeners see transitions
export const [getKnownUser, setKnownUser, useKnownUser, onKnownUser] = createStore(false);

onProfile((profile) => {
	const known = isKnownUser(profile);

	if (known !== getKnownUser()) {
		setKnownUser(known);
	}
});
